import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
};

export let db, auth, storage;
export let FIREBASE_READY    = false;
export let STORAGE_READY     = false;

try {
  if (
    process.env.REACT_APP_FIREBASE_API_KEY &&
    process.env.REACT_APP_FIREBASE_PROJECT_ID
  ) {
    const app = initializeApp(firebaseConfig);
    db    = getFirestore(app);
    auth  = getAuth(app);
    FIREBASE_READY = true;

    /* Storage is optional — only initialise if a bucket is configured */
    if (process.env.REACT_APP_FIREBASE_STORAGE_BUCKET) {
      try {
        storage      = getStorage(app);
        STORAGE_READY = true;
      } catch (storageErr) {
        console.warn("Firebase Storage init failed:", storageErr.message);
      }
    }
  }
} catch (e) {
  console.warn("Firebase init failed:", e.message);
}
